export default __webpack_public_path__ + "f1f781425a9a5c3732d99d3a2de7954c.png";